import React, { useContext } from 'react'
import { FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { ActiveOverlayContext } from 'src/Components/shared/Routing/OverlayContext'

// Components
import { If, Unless, Button, Text, StatusIcon } from 'src/Components'

// Styles
import styles from './OutreachButton.module.scss'

const propTypes = {
  className: PropTypes.string,
  requested: PropTypes.bool,
  success: PropTypes.bool.isRequired,
  failure: PropTypes.bool.isRequired,
  iconStart: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
  buttonMessage: PropTypes.shape({
    id: PropTypes.string,
    defaultMessage: PropTypes.string
  }).isRequired,
  resultMessage: PropTypes.shape({
    id: PropTypes.string,
    defaultMessage: PropTypes.string
  }).isRequired,
  handleClick: PropTypes.func.isRequired
}

const OutreachButton = ({
  buttonMessage,
  className,
  failure,
  handleClick,
  iconStart,
  requested,
  resultMessage,
  success
}) => {
  const { exitingPanel } = useContext(ActiveOverlayContext) || {
    exitingPanel: false
  }

  return (
    <div
      data-qa='outreach-btn-component'
      className={classnames(styles.container, className)}
    >
      <Unless condition={success || failure}>
        <Button
          data-qa='outreach-btn'
          className={styles.button}
          fullWidth
          iconStart={iconStart}
          loading={requested}
          onClick={handleClick}
        >
          <FormattedMessage id='Default' {...buttonMessage} />
        </Button>
      </Unless>
      <div
        className={classnames(
          exitingPanel && styles.disableShow,
          styles.slideOpenContainer,
          (success || failure) && styles.ready
        )}
      >
        <StatusIcon
          className={classnames(styles.icon, failure && styles.failure)}
          failure={failure}
          spin={!success && !failure}
          success={success}
        />
        <Text
          color='quiet'
          size='s'
          element='span'
          className={styles.resultText}
        >
          <If condition={success || failure}>
            <FormattedMessage id='Default' {...resultMessage} />
          </If>
        </Text>
      </div>
    </div>
  )
}

OutreachButton.propTypes = propTypes

export default OutreachButton
